import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter } from 'react-router-dom';
import { ModalsContextProvider } from 'contexts/ModalsContext';
import App from './App';
import { LoadingIndicator } from './components/shared';
import { AddressProvider } from './contexts/Address';
import { BrowserHistoryProvider } from './contexts/BrowserHistory';
import { CartProvider } from './contexts/Cart';
import { CustomerProvider } from './contexts/Customer';
import { DarkstoreProvider } from './contexts/Darkstore';
import './lib/i18n';
import './lib/polyfill';
import './lib/yup';
import queryClient from './queryClient';
import reportWebVitals from './reportWebVitals';
import './setupCssVariables';
import { MessagesOutlet } from './utils/message';
import './styles/index.scss';

const handleRouteChange = () => {
  const notFoundBlock = document.getElementById('custom-not-found');
  if (notFoundBlock) notFoundBlock.remove();
};

window.addEventListener('popstate', handleRouteChange);

document.addEventListener('click', e => {
  if (e.target.tagName === 'A') {
    setTimeout(handleRouteChange, 100);
  }

  if (e.target.tagName === 'BUTTON') {
    setTimeout(handleRouteChange, 100);
  }

  if (e.target.tagName === 'NAV') {
    setTimeout(handleRouteChange, 100);
  }
});

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<LoadingIndicator />}>
      <BrowserRouter>
        <BrowserHistoryProvider>
          <QueryClientProvider client={queryClient}>
            <DarkstoreProvider>
              <AddressProvider>
                <CustomerProvider>
                  <CartProvider>
                    <ModalsContextProvider>
                      <App />
                    </ModalsContextProvider>
                  </CartProvider>
                </CustomerProvider>
              </AddressProvider>
            </DarkstoreProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </BrowserHistoryProvider>
      </BrowserRouter>
      <MessagesOutlet />
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
